module.exports = __webpack_public_path__ + "static/img/lock.8634238d.svg";